import { FireIcon } from '@phosphor-icons/react';

import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Flame = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return <FireIcon color={fill} {...rest} size={Sizes[size]} />;
};

Flame.displayName = 'Flame';
